/**
 * SEO 配置 - chat (Türkçe)
 */

export default {
    chat: {
        title: 'AI Sohbet - Çoklu Model Asistanı | WeryAI',
        description:
            'WeryAI\'da en iyi AI modelleriyle sohbet edin. Birden fazla pencerede yanıtları yan yana karşılaştırın. Tek bir AI çalışma alanından görsel, video ve müzik oluşturun.',
        keywords:
            'AI sohbet, AI asistan, çoklu model sohbet, AI chatbot, AI modelleri karşılaştır, yan yana AI sohbet, GPT alternatifi, AI çalışma alanı, WeryAI',
        og_title: 'AI Sohbet - Çoklu Model Asistanı | WeryAI',
        og_description:
            'En iyi AI modelleriyle sohbet edin ve yanıtları yan yana karşılaştırın. Görsel, video ve daha fazlasını oluşturun. WeryAI\'da ücretsiz deneyin.',
        twitter_title: 'AI Sohbet - Çoklu Model Asistanı | WeryAI',
        twitter_description:
            'En iyi AI modelleriyle sohbet edin ve yanıtları yan yana karşılaştırın. Görsel, video ve daha fazlasını oluşturun. WeryAI\'da ücretsiz deneyin.',
    },
}
